module.exports = __webpack_public_path__ + "static/media/elements.019f2563.png";